var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17146 6.83151C8.50352 6.23292 8.43726 5.49201 8.00429 4.96204L6.24322 2.80641C5.93071 2.42388 5.35672 2.39521 5.00775 2.7447L3.27799 4.47704C2.00711 5.7518 2.49978 7.60927 3.29215 9.23279C5.06713 12.8696 7.49893 15.2973 10.777 16.729C12.4292 17.4505 14.255 18.018 15.5259 16.7432L17.2557 15.0109C17.6046 14.6614 17.576 14.0865 17.194 13.7736L15.0416 12.0099C14.5124 11.5763 13.7726 11.5099 13.1749 11.8425L11.1031 12.9952C9.12637 11.6146 8.42742 10.9268 7.02041 8.90649L8.17146 6.83151Z",
    stroke: "#4B5563",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.1a87dbd44401672639223f087e12990f.svg";
export { ForwardRef as ReactComponent };